import { useState, useEffect, useContext } from "react";
import EventContext from "../store/event-context";
import { Container, Stack, Typography, Box } from "@mui/material";

const TestDimensions = () => {

  const eventctx = useContext(EventContext);
  const orientationPortrait = (window.innerWidth < window.innerHeight);
  console.log(navigator.userAgent);

  return (
    <Container id="testDimensionsOuterContainer" sx={{ width: orientationPortrait? '95%': '40%'}} >
      <Stack sx={{marginTop: 3 }} direction='column' id="testDimensionsStack" alignItems='center'>
        <Typography>{eventctx.event.name}</Typography>

        <Typography sx={{ marginTop: 2 }} >{`DocElmClientWidth: ${document.documentElement.clientWidth}`}</Typography>
        <Typography>{`DocElmClientHeight: ${document.documentElement.clientHeight}`}</Typography>

        <Typography sx={{ marginTop: 2 }} >{`WindowInnerWidth: ${window.innerWidth}`}</Typography>
        <Typography>{`WindowInnerHeight: ${window.innerHeight}`}</Typography>

        <Typography sx={{ marginTop: 2 }} >{`WindowScreenWidth: ${window.screen.width}`}</Typography>
        <Typography>{`WindowScreenHeight: ${window.screen.height}`}</Typography>


      <Box id="footerBox" position="absolute" bottom="10px" >
        <Typography id="footer-content" align="center" sx={{ fontSize: '12px'}} >
        Developed by: <div><img src="./Cgi-logo-small.png" width="40" height="25" alt="CGI logo"/></div>
        </Typography>
      </Box>
      </Stack>
    </Container>
  );
};

export default TestDimensions;
